
import { useState } from "react";
import { useCandidatesFilter } from "@/contexts/CandidatesFilterContext";
import { CandidatesGrid } from "@/components/candidates/CandidatesGrid";
import { CandidatesList } from "@/components/candidates/CandidatesList";
import { CandidatesViewOptions, SortField } from "@/components/candidates/CandidatesViewOptions";
import { CandidatesPagination } from "@/components/candidates/CandidatesPagination";
import { useCandidatesFiltering } from "@/hooks/candidates/useCandidatesFiltering";
import { Candidate } from "@/types/candidate";

interface CandidatesContentProps {
  candidates: Candidate[];
  isLoading: boolean;
}

export const CandidatesContent = ({
  candidates,
  isLoading
}: CandidatesContentProps) => {
  const {
    searchTerm,
    skillsFilter,
    statusFilter,
    functionFilter,
    sortField,
    setSortField,
    sortOrder,
    setSortOrder,
    viewMode,
    setViewMode,
    currentPage,
    setCurrentPage
  } = useCandidatesFilter();

  const { paginatedCandidates, totalPages } = useCandidatesFiltering(
    candidates,
    searchTerm,
    skillsFilter,
    statusFilter,
    functionFilter,
    sortField,
    sortOrder,
    currentPage
  );

  // Reset to first page when sort field or order changes
  const handleSortFieldChange = (field: SortField) => {
    setSortField(field);
    setCurrentPage(1);
  };

  return (
    <div>
      <CandidatesViewOptions 
        sortField={sortField}
        setSortField={handleSortFieldChange}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        viewMode={viewMode}
        setViewMode={setViewMode}
      />
      
      {viewMode === "card" ? (
        <CandidatesGrid 
          candidates={candidates}
          filteredCandidates={paginatedCandidates}
          isLoading={isLoading}
        />
      ) : (
        <CandidatesList 
          candidates={candidates}
          filteredCandidates={paginatedCandidates}
          isLoading={isLoading}
        />
      )}
      
      {totalPages > 1 && (
        <CandidatesPagination 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
};
